module.exports = __webpack_public_path__ + "static/img/commovement-banner.edeabe4a.png";